// extracted by mini-css-extract-plugin
export default {"videoTextHeader":"PromoVideo_videoTextHeader__4Ng7+"};